import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
  AppBarWide,
  AppFlyoutHeightMaxWidth400,
  AppFlyoutMaxHeight,
  AppFlyoutMinHeight,
  AppFlyoutNoFooterHeight,
  AppFlyoutSmallMaxHeight,
  AppFlyoutSmallMinHeight,
  AppFlyoutWidth,
  AppFlyoutWidthMaxWidth400,
  TileDimensionDefault,
  TileHeightWide,
  VisualRefresh,
} from "./Constants";
const forcedColors = {
  "@media (forced-colors: active)": {
    forcedColorAdjust: "none",
    backgroundColor: "Highlight",
  },
};
export const useFlyoutButtonStyles = makeStyles({
  moreAppsButton: {
    ...shorthands.borderWidth(0),
    minWidth: TileDimensionDefault,
    height: TileDimensionDefault,
    width: TileDimensionDefault,
    boxShadow: "none",
    backgroundColor: tokens.colorSubtleBackground,
    fontWeight: tokens.fontWeightRegular,
    ":focus-visible": {
      outlineWidth: "2px",
      outlineStyle: "solid",
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: "-2px",
      boxShadow: "none",
    },
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground4Selected,
      boxShadow: "none",
      ...forcedColors,
    },
    userSelect: "none",
  },
  moreAppsButtonContainer: {
    position: "relative",
  },
  moreAppsButtonSelected: {
    backgroundColor: tokens.colorNeutralBackground4Selected,
    ...forcedColors,
  },
  wideMoreAppsButton: {
    minWidth: AppBarWide,
    width: AppBarWide,
    height: TileHeightWide,
    ...shorthands.borderRadius(0),
  },
  roundedTileButtonContainer: {
    display: "flex",
    height: VisualRefresh.tileContainerHeight,
    width: VisualRefresh.tileContainerWidth,
    justifyContent: "center",
    alignItems: "center",
  },
  roundedTileButton: {
    minWidth: VisualRefresh.tileMinWidth,
    width: VisualRefresh.tileWidth,
    height: VisualRefresh.tileHeight,
    ...shorthands.borderRadius(VisualRefresh.tileBorderRadius),
  },
  roundedTileButtonSelected: {
    ...shorthands.outline(
      tokens.strokeWidthThin,
      "solid",
      tokens.colorNeutralStrokeAlpha
    ),
  },
  flyoutContainer: {
    width: AppFlyoutWidth,
    maxHeight: AppFlyoutMaxHeight,
    minHeight: AppFlyoutMinHeight,
    boxShadow: tokens.shadow64,
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.padding(0),
    "@media (max-width: 400px)": {
      width: AppFlyoutWidthMaxWidth400,
    },
    "@media (max-height: 502px)": {
      minHeight: AppFlyoutHeightMaxWidth400,
      maxHeight: AppFlyoutHeightMaxWidth400,
    },
  },
  flyoutContainerNoFooter: {
    maxHeight: AppFlyoutNoFooterHeight,
    minHeight: AppFlyoutSmallMinHeight,
    paddingBottom: "20px",
    "@media (max-width: 400px)": {
      width: AppFlyoutWidthMaxWidth400,
    },
    "@media (max-height: 502px)": {
      minHeight: AppFlyoutHeightMaxWidth400,
      maxHeight: AppFlyoutHeightMaxWidth400,
    },
  },
  flyoutContainerSmall: {
    maxHeight: AppFlyoutSmallMaxHeight,
    minHeight: AppFlyoutSmallMinHeight,
    height: "auto",
  },
});
